export default function CandidateSourcingDownloadIco() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 11.3008V18.3008C1 18.8312 1.21071 19.3399 1.58579 19.715C1.96086 20.0901 2.46957 20.3008 3 20.3008H17C17.5304 20.3008 18.0391 20.0901 18.4142 19.715C18.7893 19.3399 19 18.8312 19 18.3008V11.3008"
        stroke="#475467"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.90039 11.3008L10.0004 15.3008L14.1004 11.3008"
        stroke="#475467"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 1.69922V13.1992"
        stroke="#475467"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
